import { SalesItemBookingChannel } from '@navio/nsdk';
import type { NoddiIconName as IconName } from 'noddi-ui-common';
import type { FilterOption } from 'noddi-ui-web';
import { SALES_ITEM_BOOKING_CHANNEL_OPTIONS } from 'noddi-util';

/** Keep in sync with `SALES_ITEM_BOOKING_CHANNEL_ICON` in noddi-ui-web. */
const salesItemBookingChannelIconMap: Record<SalesItemBookingChannel, IconName> = {
  [SalesItemBookingChannel.MOBILE]: 'Truck',
  [SalesItemBookingChannel.STATIONARY]: 'Building2'
};

export const SALES_ITEM_BOOKING_CHANNEL_FILTER_OPTIONS: FilterOption<SalesItemBookingChannel>[] =
  SALES_ITEM_BOOKING_CHANNEL_OPTIONS.map((opt) => ({
    ...opt,
    icon: salesItemBookingChannelIconMap[opt.value]
  }));

/** Title and description of this filter, for the builder next to its options. */
export const SALES_ITEM_BOOKING_CHANNEL_FILTER_TEXT = {
  title: 'Booking channel',
  description: 'Mobile: home / address booking. Stationary: service-center booking. Items can support both channels.'
};
